import DoUtility from "../do_utility";
export default class MobileLeadDriverInit {
    constructor() {
        this._containerElement = null;
        this._timeoutId = undefined;
        this._isMobile = false;
        this._coordinates = null;
        this.initialize = async () => {
            if (!this._containerElement)
                return;
            const deviceType = this._containerElement.dataset.mldDeviceType;
            const hasRestrictedOffers = this._containerElement.dataset.mldRestrictedOffers === "true";
            this._isMobile = globalThis.innerWidth <= 991;
            if ((this._isMobile && deviceType === "desktop") ||
                (!this._isMobile && deviceType === "mobile")) {
                return;
            }
            if (hasRestrictedOffers) {
                this.tryGetLocation();
            }
            else {
                await this.fetchMobileLeadDriver();
            }
        };
        this.tryGetLocation = () => {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition(this.gotLocation, this.failedToGetLocation, { enableHighAccuracy: true });
                this._timeoutId = setTimeout(() => this.failedToGetLocation(), 30000);
            }
            else {
                this.failedToGetLocation();
            }
        };
        this.gotLocation = async (position) => {
            clearTimeout(this._timeoutId);
            await this.fetchMobileLeadDriver(position);
        };
        this.failedToGetLocation = async () => {
            clearTimeout(this._timeoutId);
            await this.fetchMobileLeadDriver();
        };
        this.fetchMobileLeadDriver = async (position) => {
            const dealerId = globalThis.DlronGlobal_DealerId;
            let path = `/api/mobileLeadDriver/${dealerId}/form`;
            if (position) {
                this._coordinates = {
                    lat: position.coords.latitude,
                    lon: position.coords.longitude,
                };
                path += `?lat=${position.coords.latitude}&lng=${position.coords.longitude}`;
            }
            // Forward the page's Orion toggle so the form's Bootstrap version can be overridden above the dealer's CLNTBAA IsOrion flag.
            const useOrionPage = new URLSearchParams(globalThis.location.search).get("useOrionPage");
            if (useOrionPage !== null) {
                path += `${path.includes("?") ? "&" : "?"}useOrionPage=${encodeURIComponent(useOrionPage)}`;
            }
            try {
                const res = await fetch(path);
                if (!res.ok)
                    return; // 404 = no valid offers
                const { html } = (await res.json());
                const { default: MobileLeadDriverForm } = await import(
                /* webpackChunkName: "mldForm" */ "./mobileLeadDriverForm");
                new MobileLeadDriverForm(html, this._isMobile, this._coordinates);
            }
            catch (err) {
                console.error(err);
            }
        };
        this._containerElement = document.getElementById("mobileLeadDriverContainer");
    }
    static initializeOnLoad() {
        const instance = new MobileLeadDriverInit();
        void instance.initialize();
    }
}
DoUtility.SelfInstantiateOnLoad(MobileLeadDriverInit.initializeOnLoad);
